import { Card, Col, Row, Typography } from "antd";
import { Logo } from "../Category/Logo";
import { getGradient } from "../../resources/theme";
import React from "react";
import logos from "../../resources/logos/SVG";
import styled from "styled-components";

const { Title } = Typography;

const leftColumnGrid = {
	xs: 6,
	sm: 6,
	md: 8,
	lg: 2,
	xl: 2,
	xxl: 2,
};

const rightColumnGrid = {
	xs: 18,
	sm: 18,
	md: 16,
	lg: 22,
	xl: 22,
	xxl: 22,
};

export const OfficeFolderBanner = ({ office, folder }) => {
	if (!office) return null;
	const { category_id } = office;

	return (
		<StyledCard folder={folder}>
			<Row align="middle">
				<Col {...leftColumnGrid} style={{ textAlign: "center" }}>
					<Logo
						size={60}
						src={logos[`logo_${category_id}_color`]}
					></Logo>
				</Col>
				<Col {...rightColumnGrid}>
					<Row>
						<Col>
							<Title level={5}>Subcategoría</Title>
						</Col>
					</Row>
					<Row>
						<Col>
							<Title level={4}>{folder}</Title>
						</Col>
					</Row>
				</Col>
			</Row>
		</StyledCard>
	);
};

const StyledCard = styled(Card)`
	position: relative;
	box-shadow: ${getGradient("shadow")};
	margin: 12px;
	max-height: 200px;

	.ant-card-body {
		border-radius: 4px;
		padding: 18px;
		background-color: #1549ac;
	}
	.ant-typography {
		color: #fff;
		margin: 0;
	}
`;
